<template>
  <section class="app-main" :style="{ 'background': urgencyShow? 'rgb(248, 144, 144' : '#fff' }">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>

import setTheme from '@/theme.js'
import { mapGetters } from 'vuex'

// 使用主题
// import setTheme from '@/theme.js'
// // 使用主题
// setTheme('chalk')

export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    ...mapGetters(['sidebar', 'avatar', 'device', 'urgencyShow'])

  },
  created() {
    setTheme('chalk')
  },
  mounted() {
    this.$nextTick(() => {
    })
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  // background-color: aquamarine; // =================================================
  width: 100%;
  position: relative;
  // overflow: hidden;
  // overflow-y:scroll
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
